/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContractRubricSummary
 */
export interface ContractRubricSummary {
    /**
     * 
     * @type {string}
     * @memberof ContractRubricSummary
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof ContractRubricSummary
     */
    sort_order: number;
}

/**
 * Check if a given object implements the ContractRubricSummary interface.
 */
export function instanceOfContractRubricSummary(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "sort_order" in value;

    return isInstance;
}

export function ContractRubricSummaryFromJSON(json: any): ContractRubricSummary {
    return ContractRubricSummaryFromJSONTyped(json, false);
}

export function ContractRubricSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractRubricSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': json['title'],
        'sort_order': json['sort_order'],
    };
}

export function ContractRubricSummaryToJSON(value?: ContractRubricSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'sort_order': value.sort_order,
    };
}

